// 月初现金余额管理
export default {
  interPool: {
    search: {
      interestDateStart: '日期从',
      interestDateEnd: '日期到',
    },
    column: {
      orderCompany: '公司',
      orderDepartment: '部门',
      interestDate: '计息日期',
      interestAmount: '计息金额',
      interestPaymentAmount: '计息金额(+)',
      interestReceiptAmount: '计息金额(-)',
      remark: '备注',
    },
    billReceivableColumn: {
      interestOrderCode: '应收票据号',
      orderDepartment: '收票部门',
      interestAmount: '收票金额',
      endorseDepartment: '背书部门',
      endorseAmount: '背书金额',
    },
    billSinceColumn: {
      interestOrderCode: '自开票据号',
      orderDepartment: '开票部门',
      interestAmount: '票据金额',
      duePaymentDate: '到期支付金额',
    },
    CLColumn: {
      clCode: '信用证号',
      issuedDepartment: '开证部门',
      internationalClAmount: '进口信用证开证金额',
      internationalPayAmount: '进口信用证付款金额',
      domesticClAmount: '国内信用证开证金额',
      domesticPayAmount: '国内信用证付款金额',
    },
    TFColumn: {
      financingAmount: '贸易融资金额',
      interestAmount: '资金利息',
    },
    button: {
      save: '保存',
      add: '新增',
      delete: '删除',
    },
    message: {
      noSelected: '您还未选择任何数据!',
      noForbid: '失效状态不能编辑！',
      onlyOneSelectData: '请选择一条数据进行操作!',
      noExport: '当前没有数据可以导出！',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
    },
  },
};
